import React, { useState, useEffect } from 'react'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import AdminFooter from '../../components/Footer/AdminFooter'
import authortrackdetailStyle from './AuthorTrackingDetailsPage.module.css'
import BackBar from '../../components/BackBar/BackBar';
import authorImg from '../../../assets/images/men-img.png'
import { useParams, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
export default function AuthorTrackingDetailsPage() {

  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/AuthorTrackingPage'); // Navigate to the Author Tracking Page
  };

  const [author, setAuthor] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const [proimage, setProimage] = useState('')
  // console.log(id, 'cid');
  useEffect(() => {


    const fetchAuthorData = async () => {
      try {

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all_admin.php?id=${id}`);
        const data = await response.json();

        if (data.success) {
          setProimage(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/author/${id}`);
          setAuthor(data.author);
        } else {
          setError(data.message);
        }
      } catch (err) {
        setError('Failed to fetch coordinator data.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchAuthorData();
  }, [id]);

  // const handleActivate = async (flag) => {
  //   let title='';
  //   let text='';
  //   if(flag ==0){
  //     title='Author Activation!';
  //     text='Author Activated Successfully!';
  //   }
  //   if(flag ==1){
  //     title='Author Deactivation!';
  //     text='Author Deativated Successfully!';
  //   }

  //       try {
  //         // Make the API call to activate the school
  //         const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all_admin.php?aid=${id}&author_activate_flag=${flag}`);
  //         const data = await response.json();
  //         if(data.success){
  //           Swal.fire({
  //                   title: title,
  //                   text: text,
  //                   icon: "success",
  //                   timer: 2000, // Pop-up duration in milliseconds
  //                   showConfirmButton: false, // No need for a confirmation button
  //                 }).then(() => {
  //                   // Redirect after pop-up
  //                  // navigate(`/ActivatedSchoolsOrgPage`);
  //                  window.location.reload();
  //                 });
  //         }
  //         else {
  //           Swal.fire({
  //             title: "Failed!",
  //             text: "Failed to activate or deactivate author!",
  //             icon: "error",
  //             timer: 2000, // Pop-up duration in milliseconds
  //             showConfirmButton: false, // No need for a confirmation button
  //           })
  //         }
  //       } catch (error) {
  //         console.error('Error activating school:', error);
  //         alert('Failed to activate school. Please try again.');
  //       }
  //     };

  const handleActivate = async (flag) => {

    const isActivating = flag == 0;

    const actionText = isActivating ? "activate" : "deactivate";

    const title = isActivating
      ? "Author Activation!"
      : "Author Deactivation!";

    const text = isActivating
      ? "Author Activated Successfully!"
      : "Author Deactivated Successfully!";

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${actionText} this author?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: `Yes, ${actionText} it!`,
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_all_admin.php?aid=${id}&author_activate_flag=${flag}`
      );

      const data = await response.json();

      if (data.success) {
        Swal.fire({
          title: title,
          text: text,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload();
        });

      } else {
        Swal.fire({
          title: "Failed!",
          text: `Failed to ${actionText} author!`,
          icon: "error",
        });
      }

    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
      });
    }
  };



  if (isLoading) return <div></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <AdminHeader />
      <div className={authortrackdetailStyle.authortrackingdetailspage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={authortrackdetailStyle.authortrackdetailBody}>
                <div className="row">
                  {/* <div className="col-xl-4 col-xxl-4">
                  <button onClick={handleClick} className={`${authortrackdetailStyle.authordetailBackbtn} btn btn-primary mb-3`}>Back</button>
                </div> */}
                </div>
                <div className="row">
                  <div className="col-xl-2 col-xxl-2">
                    <div className="align-items-center">
                      <div className={`${authortrackdetailStyle.authortrackImg} rounded-circle mb-2`}>
                        <img src={proimage} className='img-fluid' />
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-5 col-xxl-5">
                    <h6>Author Information</h6>
                    <div className="row">
                      <div className="col-xl-6 col-xxl-6">
                        <div className="mb-2">
                          <label className={`${authortrackdetailStyle.authordetailLabel} form-label`}>First Name</label>
                          <input type="text" className={`${authortrackdetailStyle.authordetailFormcontrol} form-control`} value={author.f_name} placeholder="First Name" />
                        </div>
                      </div>
                      <div className="col-xl-6 col-xxl-6">
                        <div className="mb-2">
                          <label className={`${authortrackdetailStyle.authordetailLabel} form-label`}>Last Name</label>
                          <input type="text" className={`${authortrackdetailStyle.authordetailFormcontrol} form-control`} value={author.l_name} placeholder="Last Name" />
                        </div>
                      </div>
                      <div className="col-xl-6 col-xxl-6">
                        <div className="mb-2">
                          <label className={`${authortrackdetailStyle.authordetailLabel} form-label`}>Email Address</label>
                          <input type="gmail" className={`${authortrackdetailStyle.authordetailFormcontrol} form-control`} value={author.email_id} placeholder="Email Address" />
                        </div>
                      </div>
                      <div className="col-xl-6 col-xxl-6">
                        <div className="mb-3">
                          <label className={`${authortrackdetailStyle.authordetailLabel} form-label`}>Phone Number</label>
                          <input type="number" className={`${authortrackdetailStyle.authordetailFormcontrol} form-control`} value={author.phone} placeholder="Phone Number" />
                        </div>
                      </div>
                    </div>
                    <h6>Password Information</h6>
                    <div className="mb-2 row align-items-center">
                      <label className={`${authortrackdetailStyle.authordetailLabel} col-sm-5 col-form-label text-end`}>Password</label>
                      <div className="col-sm-7">
                        <input type="password" className={`${authortrackdetailStyle.authordetailFormcontrol} form-control`} value={author.password} placeholder="" />
                      </div>
                    </div>
                    <div className="mb-2 row align-items-center">
                      <label className={`${authortrackdetailStyle.authordetailLabel} col-sm-5 col-form-label text-end`}>Confirm Password</label>
                      <div className="col-sm-7">
                        <input type="password" className={`${authortrackdetailStyle.authordetailFormcontrol} form-control`} placeholder="" />
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-1 col-xxl-1"> </div>
                  <div className="col-xl-4 col-xxl-4">
                    <div className="d-flex">
                      <h6 className="me-3">Status</h6>
                      <div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" onClick={() => handleActivate(0)} checked={author.flag == 0} />
                          <label className={`${authortrackdetailStyle.authordetailLabel} form-check-label pb-0`} for="flexRadioDefault1"> Activate </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onClick={() => handleActivate(1)} checked={author.flag == 1} />
                          <label className={`${authortrackdetailStyle.authordetailLabel} form-check-label pb-0`} for="flexRadioDefault2"> Deactivate </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}
